import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Editform = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [entry, setEntry] = useState({ ...state.entry, token_id: state.entry.token_id });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEntry((prevEntry) => ({
            ...prevEntry,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        console.log('Entry data before saving:', JSON.stringify(entry, null, 2)); // Log the entry data
        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/edit-form.php', {
                action: 'update',
                ...entry,
            });

            console.log('Server response:', response.data);

            if (response.data && response.data.status === 'success') {
                alert('Entry updated successfully!');
                navigate('/form-list');
            } else {
                const errorMsg = response.data.message || 'Failed to update entry';
                setError(errorMsg);
                alert(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err); 
            setError('Error updating entry. Please try again later.');
        }
    };

    return (
        <div className="arms-container">
        <form>
            <div className="firright-section">
                <div className="firdiv">
                    <label id="l1">نام و سکونت ملزم:</label>
                    <input
                        type="text"
                        name="criminal_loc"
                        value={entry.criminal_loc}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l2">کاورائی متعلقہ:</label>
                    <input
                        type="text"
                        name="operation"
                        value={entry.operation}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l3">تھانہ سے رانگی تاریخ:</label>
                    <input
                        type="date"
                        name="d_date"
                        value={entry.d_date}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l4">تھانہ سے راونگی وقت:</label>
                    <input
                        type="time"
                        name="d_time"
                        value={entry.d_time}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l5">ریمارکس:</label>
                    <input
                        type="text"
                        name="remarks"
                        value={entry.remarks}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l6">فون نمبر:</label>
                    <input
                        type="text"
                        name="phone_no"
                        value={entry.phone_no}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l7">سٹیٹس:</label>
                    <input
                        type="text"
                        name="status_f"
                        value={entry.status_f}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l8">زیر حراست:</label>
                    <input
                        type="text"
                        name="under_inquiry"
                        value={entry.under_inquiry}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l9">ضمانت یا مچلکہ پر:</label>
                    <input
                        type="text"
                        name="paid_quiry"
                        value={entry.paid_quiry}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l10">مال معہ ہتھیار باز یافتہ مقام ووقت پرآمدگی کس نے برآمد کیا عدالت میں بھیجا گیا یا نہیں:</label>
                    <input
                        type="text"
                        name="weapon"
                        value={entry.weapon}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l11">گواہان:</label>
                    <input
                        type="text"
                        name="witness"
                        value={entry.witness}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l12">الزام یا اطلاع:</label>
                    <input
                        type="text"
                        name="crime_news"
                        value={entry.crime_news}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l13">بنام:</label>
                    <input
                        type="text"
                        name="name"
                        value={entry.name}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>
            <div className="firleft-section">
                <div className="firdiv">
                    <label id="l14">ٹوکن آئی ڈی:</label>
                    <input
                        type="text"
                        name="token_id"
                        value={entry.token_id}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l15">سیریل نمبر:</label>
                    <input
                        type="text"
                        name="sr_no"
                        value={entry.sr_no}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l16">بوک نمبر:</label>
                    <input
                        type="text"
                        name="book_no"
                        value={entry.book_no}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l17">نمبر:</label>
                    <input
                        type="text"
                        name="no"
                        value={entry.no}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l18">تھانہ:</label>
                    <input
                        type="text"
                        name="thana"
                        value={entry.thana}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l19">ضلع:</label>
                    <input
                        type="text"
                        name="district"
                        value={entry.district}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l20">تاریخ:</label>
                    <input
                        type="date"
                        name="date"
                        value={entry.date}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l21">وقت:</label>
                    <input
                        type="time"
                        name="time"
                        value={entry.time}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l22">تاریخ رپورٹ:</label>
                    <input
                        type="date"
                        name="r_date"
                        value={entry.r_date}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="firdiv">
                    <label id="l23">وقت رپورٹ:</label>
                    <input
                        type="time"
                        name="r_time"
                        value={entry.r_time}
                        onChange={handleChange}
                        required
                    />
                </div>
            <button type="button" onClick={handleSave}>Save</button>
            <button type="button" onClick={() => navigate('/form-list')}>Cancel</button>
            </div>
        </form>
    </div>
    
    
    );
};

export default Editform;
